import React from 'react';
import { string, number, oneOfType } from 'prop-types';
import { Icon } from '@atoms';
import { Flex } from '@mixins';
import { common } from '@constants';
import { client } from '@utils';
import { ReactComponent as Pdf } from '@assets/svgs/Pdf.svg';
import { ReactComponent as Download } from '@assets/svgs/Download.svg';

const InvoiceCell = ({ invoiceUrl, invoiceNumber }) => {
  const isApiInvoiceUrl = invoiceUrl.startsWith(common.BASE_URL);

  const getFileName = () => {
    const [urlFileName] = invoiceUrl.split('?')[0].split('/').slice(-1);
    const extension = urlFileName.includes('.') ? urlFileName.split('.').pop() : 'pdf';

    return invoiceNumber ? `${invoiceNumber}.${extension}` : urlFileName || 'invoice.pdf';
  };

  const handleOpenClick = () => {
    window.open(invoiceUrl, '_blank', 'noopener,noreferrer');
  };

  // The invoice is served by our API for authorized requests only, so it has to be
  // fetched with the token attached and saved as a blob, not linked to directly.
  const fetchInvoiceBlob = async () => {
    if (isApiInvoiceUrl) {
      const { data } = await client.authorized.get(invoiceUrl, { responseType: 'blob' });

      return data;
    }

    const response = await fetch(invoiceUrl);

    if (!response.ok) {
      throw new Error(`Invoice request failed with status ${response.status}`);
    }

    return response.blob();
  };

  const handleDownloadClick = async () => {
    try {
      const objectUrl = URL.createObjectURL(await fetchInvoiceBlob());

      const link = document.createElement('a');
      link.href = objectUrl;
      link.download = getFileName();
      document.body.appendChild(link);
      link.click();
      link.remove();

      // Revoking right away cancels the download in Firefox & Safari.
      setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
    } catch (error) {
      handleOpenClick();
    }
  };

  return (
    <Flex width="100%" height="100%" alignItems="center">
      <Icon pointer mr="14px" width="20px" height="20px" SVG={Pdf} onClick={handleOpenClick} />
      <Icon pointer width="20px" height="20px" SVG={Download} onClick={handleDownloadClick} />
    </Flex>
  );
};

InvoiceCell.defaultProps = {
  invoiceNumber: '',
};

InvoiceCell.propTypes = {
  invoiceUrl: string.isRequired,
  invoiceNumber: oneOfType([string, number]),
};

export default InvoiceCell;
